import React, { FC } from 'react';
import { VStack } from '@chakra-ui/react';

import Callout from 'components/_core/Callout';
import Heading from 'components/_core/Heading';
import SunshineCard from 'components/_core/SunshineCard';
import SquircleIcon from 'components/_core/SunshineSquircleIcon';
import Text from 'components/_core/Text';
import BackButton from 'components/BackButton';
import StepperProgressBar from 'components/Stepper/StepperProgressBar';
import { StepProps } from 'components/Stepper/types';
import * as Layout from 'layouts/StepperLayout';

import { CtaButton } from '../../../components/Buttons';
import { usePhysicalCardOrderFlowContext } from '../../hooks/usePhysicalCardOrderFlowContext';
import locales from './locales';

const PhysicalCardOrderVerifyPersonalAddress: FC<StepProps> = (props) => {
  const { goNext } = props;

  const {
    flowConfig: {
      coordinates: {
        fullName,
        personalAddress: { city, street, streetAddition, zip },
      },
    },
  } = usePhysicalCardOrderFlowContext();

  const onAddInfoPressed = () => {
    goNext({ key: 'add-delivery-info' });
  };
  const onGoNextPressed = () => {
    goNext({ key: 'card-pin' });
  };

  return (
    <Layout.Root>
      <Layout.Body>
        <Layout.HeaderButtonsContainer>
          <BackButton />
        </Layout.HeaderButtonsContainer>

        <Layout.BodyScrollableSection>
          <Heading size="lg">{locales.title}</Heading>

          <VStack marginTop="space-16" spacing="space-32">
            <SunshineCard onClick={onAddInfoPressed} title={fullName}>
              <SunshineCard.Slot name="aside">
                <SquircleIcon name="company" />
              </SunshineCard.Slot>
              <SunshineCard.Content>
                <Text>{street}</Text>
                {streetAddition ? <Text>{streetAddition}</Text> : null}
                <Text>
                  {zip} {city}
                </Text>
              </SunshineCard.Content>

              <SunshineCard.Slot name="action">
                <SunshineCard.SunshineIcon name="chevron-right" />
              </SunshineCard.Slot>
            </SunshineCard>
            <Callout variant="info">
              <Callout.Title>{locales.infoBoxTitle}</Callout.Title>
              <Callout.Content>{locales.infoBoxDescription}</Callout.Content>
            </Callout>
          </VStack>
        </Layout.BodyScrollableSection>

        <Layout.FooterContainer>
          <StepperProgressBar />
          <Layout.FooterButtonsContainer>
            <CtaButton onClick={onGoNextPressed}>{locales.next}</CtaButton>
          </Layout.FooterButtonsContainer>
        </Layout.FooterContainer>
      </Layout.Body>
    </Layout.Root>
  );
};

export default PhysicalCardOrderVerifyPersonalAddress;
